import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAdminById } from "../../services/apiServices";
import {
  Button,
  Spinner,
  Alert,
  Table,
  Badge,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";

const ViewAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const getAdmin = async () => {
      try {
        setLoading(true);
        const response = await fetchAdminById(id);

        const adminData = response?.data?.data || response?.data || null;
        setAdmin(adminData);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch admin details");
      } finally {
        setLoading(false);
      }
    };

    getAdmin();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center p-4">
        <Spinner color="primary" />
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }

  if (!admin) {
    return <Alert color="warning">Admin not found</Alert>;
  }

  return (
    <div className="page-content">
      <Card className="shadow-sm border-0">
        <CardHeader className="bg-primary text-white">
          <h5 className="mb-0">Admin Details</h5>
        </CardHeader>
        <CardBody>
          <Table bordered striped responsive>
            <tbody>
              <tr>
                <th style={{ width: "30%" }}>Name</th>
                <td>{admin.name}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{admin.email}</td>
              </tr>
              <tr>
                <th>Role</th>
                <td>{admin.role}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>
                  <Badge color={admin.isActive ? "success" : "danger"}>
                    {admin.isActive ? "Active" : "Inactive"}
                  </Badge>
                </td>
              </tr>
              <tr>
                <th>Created At</th>
                <td>{new Date(admin.createdAt).toLocaleString()}</td>
              </tr>
              <tr>
                <th>Updated At</th>
                <td>{new Date(admin.updatedAt).toLocaleString()}</td>
              </tr>
            </tbody>
          </Table>

          <Button color="secondary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default ViewAdmin;
